import { Injectable, RendererFactory2, Renderer2, Inject } from "@angular/core";
import { DOCUMENT } from "@angular/common";

// To add theme to our application

@Injectable({
  providedIn: "root",
})
export class LayoutService {
  renderer: Renderer2;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  addBodyClass(bodyClass) {
    console.log("addBodyClass");
    this.renderer.addClass(this.document.body, bodyClass);
  }
  removeBodyClass(bodyClass) {
    this.renderer.removeClass(this.document.body, bodyClass);
  }
}
